export const suppliersIt: Record<string, string> = {
  // Common
  'common.back': 'Indietro',

  // Supplier list page
  'supplier.list.title': 'Fornitori',
  'supplier.list.subtitle': 'Gestisci la tua rete di fornitori',
  'supplier.list.loading': 'Caricamento fornitori...',
  'supplier.list.deleteConfirm': 'Sei sicuro di voler eliminare {name}?',
  'supplier.list.error.title': 'Errore nel caricamento dei fornitori',
  'supplier.list.error.description': 'Si è verificato un errore durante il caricamento dei fornitori.',
  'supplier.list.empty.title': 'Nessun fornitore trovato',
  'supplier.list.empty.searchDescription': 'Nessun fornitore corrisponde alla ricerca o ai filtri attuali.',
  'supplier.list.empty.defaultDescription': 'Inizia aggiungendo il tuo primo fornitore.',
  'supplier.list.empty.addFirst': 'Aggiungi il Primo Fornitore',

  // Supplier table columns
  'supplier.table.name': 'Nome',
  'supplier.table.contact': 'Contatto',
  'supplier.table.leadTime': 'Tempo di Consegna',
  'supplier.table.leadTimeValue': '{count} giorni',
  'supplier.table.products': 'Prodotti',
  'supplier.table.performance': 'Performance',
  'supplier.table.actions': 'Azioni',

  // Supplier actions
  'supplier.actions.add': 'Aggiungi Fornitore',
  'supplier.actions.edit': 'Modifica',
  'supplier.actions.delete': 'Elimina',

  // Supplier messages
  'supplier.messages.error': 'Si è verificato un errore.',
  'supplier.messages.created': 'Fornitore creato con successo.',
  'supplier.messages.updated': 'Fornitore aggiornato con successo.',
  'supplier.messages.deleted': 'Fornitore eliminato con successo.',
  'supplier.messages.loadProductsError': 'Impossibile caricare i prodotti.',
  'supplier.messages.productRemoved': 'Prodotto rimosso con successo.',
  'supplier.messages.productRemoveError': 'Impossibile rimuovere il prodotto.',

  // Supplier detail page
  'supplier.detail.notFound.title': 'Fornitore Non Trovato',
  'supplier.detail.notFound.description': 'Il fornitore che stai cercando non esiste o è stato rimosso.',
  'supplier.detail.tabs.profile': 'Profilo',
  'supplier.detail.tabs.pricing': 'Prezzi',
  'supplier.detail.tabs.products': 'Prodotti',
  'supplier.detail.tabs.pos': 'Ordini di Acquisto',
  'supplier.detail.tabs.performance': 'Performance',
  'supplier.detail.contactInfo': 'Informazioni di Contatto',
  'supplier.detail.businessDetails': 'Dettagli Aziendali',
  'supplier.detail.taxId': 'Partita IVA',
  'supplier.detail.leadTime': '{count} giorni di anticipo',
  'supplier.detail.performanceScore': 'Punteggio Performance',
  'supplier.detail.productsCount': 'Prodotti',
  'supplier.detail.notes': 'Note',

  // Supplier products tab
  'supplier.products.title': 'Prodotti Forniti',
  'supplier.products.loading': 'Caricamento prodotti...',
  'supplier.products.count': '{count} prodotti',
  'supplier.products.search': 'Cerca prodotti...',
  'supplier.products.empty.search': 'Nessun prodotto trovato per la ricerca.',
  'supplier.products.empty.default': 'Nessun prodotto assegnato a questo fornitore.',
  'supplier.products.empty.hint': 'Assegna prodotti a questo fornitore tramite la scheda Listino Prezzi o la pagina Prodotti.',
  'supplier.products.table.product': 'Prodotto',
  'supplier.products.table.sku': 'SKU',
  'supplier.products.table.costPrice': 'Prezzo di Costo',
  'supplier.products.table.currency': 'Valuta',
  'supplier.products.table.actions': 'Azioni',

  // Supplier pricing tab
  'supplier.pricing.title': 'Listino Prezzi',
  'supplier.pricing.addPrice': 'Aggiungi Prezzo',
  'supplier.pricing.saving': 'Salvataggio...',
  'supplier.pricing.saveChanges': 'Salva Modifiche',
  'supplier.pricing.empty': 'Nessun prezzo configurato.',
  'supplier.pricing.addFirst': 'Aggiungi il Primo Prezzo',
  'supplier.pricing.selectProduct': 'Seleziona prodotto...',
  'supplier.pricing.table.product': 'Prodotto',
  'supplier.pricing.table.costPrice': 'Prezzo di Costo',
  'supplier.pricing.table.currency': 'Valuta',
  'supplier.pricing.messages.loadError': 'Impossibile caricare i dati dei prezzi.',
  'supplier.pricing.messages.noValidPrices': 'Nessun prezzo valido da salvare.',
  'supplier.pricing.messages.saved': 'Prezzi salvati con successo.',
  'supplier.pricing.messages.saveError': 'Impossibile salvare i prezzi.',

  // Supplier performance tab
  'supplier.performance.title': 'Metriche di Performance',
  'supplier.performance.badges.excellent': 'Eccellente',
  'supplier.performance.badges.good': 'Buono',
  'supplier.performance.badges.fair': 'Sufficiente',
  'supplier.performance.badges.poor': 'Scarso',
  'supplier.performance.metrics.onTimeDelivery': 'Consegna Puntuale',
  'supplier.performance.metrics.qualityScore': 'Punteggio Qualità',
  'supplier.performance.metrics.responseTime': 'Tempo di Risposta',
  'supplier.performance.ordersOf': '{onTime} su {total} ordini',
  'supplier.performance.basedOnFeedback': 'Basato sui feedback',
  'supplier.performance.averageResponse': 'Risposta media',
  'supplier.performance.delivery.title': 'Performance di Consegna',
  'supplier.performance.delivery.onTime': 'Consegne puntuali',
  'supplier.performance.delivery.late': 'Consegne in ritardo',
  'supplier.performance.delivery.avgDelay': 'Ritardo medio (quando in ritardo)',
  'supplier.performance.delivery.days': '{count} giorni',
  'supplier.performance.chart.title': 'Grafico Storico delle Performance',
  'supplier.performance.chart.description': 'I grafici interattivi con le tendenze delle performance nel tempo saranno disponibili qui.',
  'supplier.performance.mockDataNote': 'Le metriche di performance mostrano attualmente dati simulati. Il monitoraggio reale sarà implementato una volta integrato il registro delle consegne con il sistema.',

  // Purchase orders tab (supplier context)
  'po.supplier.noPOs': 'Nessun ordine di acquisto per questo fornitore.',
  'po.table.number': 'Numero OA',
  'po.table.status': 'Stato',
  'po.table.expectedDelivery': 'Consegna Prevista',
  'po.table.total': 'Totale',
  'po.table.createdAt': 'Creato',
};
